import { render, staticRenderFns } from "./TheNews.vue?vue&type=template&id=50179d9d&"
import script from "./TheNews.vue?vue&type=script&lang=js&"
export * from "./TheNews.vue?vue&type=script&lang=js&"
import style0 from "./TheNews.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports